import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { eventEmitter } from "../../api/eventEmitter";
import { updateAuthorized } from "../DataExtractionTool/Authentication/authenticationSlice";

// Import Chiesi components
import DashboardPage from "./pages/DashboardPage/DashboardPage";
import FileUpload from "./components/FileUpload/FileUpload";
import CompletedJobsPage from "./pages/CompletedJobsPage/CompletedJobsPage";
import InProgressJobsPage from "./pages/InProgressJobsPage/InProgressJobsPage";
import DisplayRecordsPage from "./pages/DisplayRecordsPage/DisplayRecordsPage";

// Authorization guard component
const ChiesiAuthGuard = ({ children }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isAuthorised } = useSelector((state) => state.authentication);
  const loginState = useSelector((state) => state.authentication);
  const user_id = loginState.user?.userId;
  
  // Authorized user IDs for Chiesi functionality
  const AUTHORIZED_USER_IDS = [1, 15, 25, 38];

  useEffect(() => {
    if (!isAuthorised || !AUTHORIZED_USER_IDS.includes(user_id)) {
      navigate("/");
    }
  }, [isAuthorised, user_id, navigate]);

  // Listen for unauthorized events from API calls
  useEffect(() => {
    const handleUnauthorized = () => {
      dispatch(updateAuthorized(false));
      navigate("/");
    };

    eventEmitter.on('unauthorized', handleUnauthorized);

    return () => {
      eventEmitter.off('unauthorized', handleUnauthorized);
    };
  }, [dispatch, navigate]);

  // Periodic session check (every 5 minutes)
  useEffect(() => {
    const sessionCheckInterval = setInterval(() => {
      // Check if user is still authorized
      if (!isAuthorised || !AUTHORIZED_USER_IDS.includes(user_id)) {
        navigate("/");
      }
    }, 5 * 60 * 1000); // 5 minutes

    return () => clearInterval(sessionCheckInterval);
  }, [isAuthorised, user_id, navigate]);

  // If not authorized, don't render children
  if (!isAuthorised || !AUTHORIZED_USER_IDS.includes(user_id)) {
    return null;
  }

  return children;
};

export default function ChiesiRoutes() {
  return (
    <ChiesiAuthGuard>
      <Routes>
        <Route path="/" element={<DashboardPage />}>
          <Route index element={<InProgressJobsPage />} />
          <Route path="fileUpload" element={<FileUpload />} />
          <Route path="completedJobs" element={<CompletedJobsPage />} />
          <Route
            path="jobRecords/:id"
            element={<DisplayRecordsPage IsInProgress={true} />}
          />
          <Route
            path="completejobRecords/:id"
            element={<DisplayRecordsPage IsInProgress={false} />}
          />
        </Route>
      </Routes>
    </ChiesiAuthGuard>
  );
} 